import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { EnvironmentalFateComponent } from './environmental-fate/environmental-fate.component';
import { EFSetupComponent } from './ef-setup/ef-setup/ef-setup.component';
import { EFSetupInputsComponent } from './ef-setup/ef-setup-inputs/ef-setup-inputs.component';
import { EFSetupModelsToBeRunComponent } from './ef-setup/ef-setup-models-to-be-run/ef-setup-models-to-be-run.component';
import { EFDataComponent } from './ef-data/ef-data/ef-data.component';

@NgModule({
  declarations: [
    EnvironmentalFateComponent,
    EFSetupComponent,
    EFSetupInputsComponent,
    EFSetupModelsToBeRunComponent,
    EFDataComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ],
  exports: [
    EnvironmentalFateComponent,
    EFSetupComponent,
    EFSetupInputsComponent,
    EFSetupModelsToBeRunComponent,
    EFDataComponent
  ]
})
export class EnvironmentalFateModule { }
